// FT-170 STEP-11. Чистые функции карточки «первые шаги» (StageCard.vue) —
// без axios и без обращения к $store, чтобы видимость и строки вех можно
// было проверить юнит-тестом без монтирования компонента.
import { ADMIN_PLUS_ROLES } from "@/constants/roles";

// Дизайн §3 («Карточка на главной»): видит только владелец/админ на
// стадиях 0–3, пока сам не скрыл карточку через `hide_stage_card`.
// Стадия 4 и отсутствие данных (axios ещё не ответил, роль неизвестна,
// эндпоинт упал) — тоже «не показывать», а не ошибка (FM-08): вызывающая
// сторона передаёт stage=null, пока ответа нет или он не 200.
export function shouldShowStageCard({ role, stage, hideStageCard }) {
  if (hideStageCard) return false;
  if (!ADMIN_PLUS_ROLES.includes(role)) return false;
  if (!Number.isInteger(stage)) return false;
  return stage >= 0 && stage <= 3;
}

// Базовый адрес справки + путь без двойного или пропущенного слэша.
// `path` может отсутствовать (стадия 4 → next_step: null) — тогда ссылки нет.
export function docsUrl(base, path) {
  if (!path) return null;
  const trimmedBase = String(base || "").replace(/\/+$/, "");
  const trimmedPath = String(path).replace(/^\/+/, "");
  return `${trimmedBase}/${trimmedPath}`;
}

// Тело карточки — три строки вех 1–3 (дизайн §3): веха 4 (`second_employee`)
// только двигает стадию и своей строки в теле не имеет. `route` — куда ведёт
// невыполненная строка; маршруты сверены с src/router/index.js.
const MILESTONE_ROWS = [
  { key: "active_priced_car", route: "/cars" },
  { key: "real_booking", route: "/booking/new" },
  { key: "completed_cycle", route: "/bookings/board" },
];

export function milestoneRows(milestones) {
  const source = milestones || {};
  return MILESTONE_ROWS.map((row) => ({
    ...row,
    done: !!source[row.key],
  }));
}
